import { css } from '@emotion/react';
import { theme } from 'global';

export const main = css`
  display: flex;
  justify-content: center;
  height: calc(100vh - var(--header-height));
  background-color: ${theme.colors.neutral[0]};
  padding: 40px 0;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    background-color: ${theme.colors.white};
  }
`;

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 496px;
  max-height: 424px;
  padding: 48px;
  border-radius: 8px;
  background-color: ${theme.colors.white};

  @media screen and (max-width: ${theme.breaks.xs}px) {
    padding: 16px;
  }

  > p.body2 {
    margin: 12px 0;
  }

  > p.body2:first-of-type {
    margin-bottom: 0;
  }
`;

export const text = css`
  margin-top: 24px;
`;

export const loginButton = css`
  margin-top: 12px;
  padding: 14px 24px;
`;
